import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=aeef01aa&functional=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports